var map = {
	"./Apceros.png": 90,
	"./Aptonoth.png": 91,
	"./Arzuros.png": 92,
	"./Ash Kecha Wacha.png": 93,
	"./Azure Rathalos.png": 94,
	"./Barioth.png": 95,
	"./Barroth.png": 96,
	"./Basarios.png": 97,
	"./Black Diablos.png": 98,
	"./Black Gravios.png": 99,
	"./Blue Yian Kut-Ku.png": 100,
	"./Brachydios.png": 101,
	"./Brute Tigrex.png": 102,
	"./Bulldrome.png": 103,
	"./Cephadrome.png": 104,
	"./Congalala.png": 105,
	"./Crimson Qurupeco.png": 106,
	"./Deviljho.png": 107,
	"./Diablos.png": 108,
	"./Emerald Congalala.png": 109,
	"./Gendrome.png": 110,
	"./Gold Rathian.png": 111,
	"./Gravios.png": 112,
	"./Great Baggi.png": 113,
	"./Great Jaggi.png": 114,
	"./Great Poogie.png": 115,
	"./Green Nargacuga.png": 116,
	"./Gypceros.png": 117,
	"./Iodrome.png": 118,
	"./Ivory Lagiacrus.png": 119,
	"./Jade Barroth.png": 120,
	"./Kecha Wacha.png": 121,
	"./Khezu.png": 122,
	"./Kirin.png": 123,
	"./Lagiacrus.png": 124,
	"./Lagombi.png": 125,
	"./Monoblos.png": 126,
	"./Nargacuga.png": 127,
	"./Nerscylla.png": 128,
	"./Pink Rathian.png": 129,
	"./Popo.png": 130,
	"./Purple Gypceros.png": 131,
	"./Purple Ludroth.png": 132,
	"./Qurupeco.png": 133,
	"./Rathalos.png": 134,
	"./Rathian.png": 135,
	"./Red Khezu.png": 136,
	"./Royal Ludroth.png": 137,
	"./Ruby Basarios.png": 138,
	"./Sand Barioth.png": 139,
	"./Seregios.png": 140,
	"./Shrouded Nerscylla.png": 141,
	"./Silver Rathalos.png": 142,
	"./Stygian Zinogre.png": 143,
	"./Tigrex.png": 144,
	"./Uragaan.png": 145,
	"./Velocidrome.png": 146,
	"./Yian Garuga.png": 147,
	"./Yian Kut-Ku.png": 148,
	"./Zamtrios.png": 149,
	"./Zinogre.png": 150
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89;


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images ^\.\/.*$
// module id = 89
// module chunks = 0